export const referenceTypes = [
    'atc',
    'article',
    'book',
    'cpt',
    'icdCode',
    'loinc',
    'rxCUI',
    'snomed',
    'upToDate',
];
export const creationStatuses = ['failed', 'succeeded'];
//# sourceMappingURL=types.js.map